//haya
import React from "react";
import { Menu, Button, Icon } from "antd";
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBCollapse,
} from "mdbreact";
import { Link, NavLink } from "react-router-dom";
import "antd/dist/antd.css";
import "../sidemenu.css";
import "../report.css";
import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import { Dropdown, Label, Divider, Form, Segment } from "semantic-ui-react";
import { Header } from "semantic-ui-react";
import Modal from "react-modal";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import { Launcher } from "react-chat-window";
import { Message } from "semantic-ui-react";
import Test from "./test.js";
import DownloadToast from "./downloadToast";
import HamburgerMenu from "react-hamburger-menu";
import ReactTooltip from "react-tooltip";
import { API_BASE_URL } from "../utils/endpoints";
import axios from "axios";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

var token = reactLocalStorage.get("accessToken");
class Menutest extends React.Component {


  constructor() {
    super();

    this.state = {
      modalIsOpen: false,
      show: false,
      show_address: false,
      show_setting: false,
      collapsed: false,
      collapseID: "",
      showStore: true,
      showsub: false,
      test: "open",
      show_account: false,
      showContact: false,
      showsub: false,
      showInvoice :false,
      dataMigrated: false,
      showAdmin: false,
      showAdminOperator: false,
      showOperatorSetting: false,
      showDownload: false,
      open: false,
      number_request: 0,
      superOperator: false,
      isArabic: false,
      messageList: [
        {
          author: "them",
          type: "text",
          data: {
            text: i18n.t("enjoy.label"),
          },
        },
      ],
      messageListaraic: [
        {
          author: "them",
          type: "text",
          data: {
            text: i18n.t("data_migrate.label"),
          },
        },
      ],
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  componentDidMount() {
    if (reactLocalStorage.get("lang") === "ar") {
      i18n.changeLanguage("ar");
    } else {
      i18n.changeLanguage("en");
    }

    var token = reactLocalStorage.get("accessToken");
    if (token === undefined) {
      window.location = "/app";
    }

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      reactLocalStorage.set("migrated", res.data.result.migrated);
      console.log(res.data.result.packageID,"res.date.result.packageIeeeD")
      
      if(res.data.result.packageID=='1692'){
        console.log('hello');
       
          this.setState({
            showInvoice:true
          })
       
      } else{
        this.setState({
          showInvoice:false
        })
      }
      if (reactLocalStorage.get("migrated") != undefined) {
        if (reactLocalStorage.get("migrated") === "false") {
          this.setState({ dataMigrated: true });
          document.querySelector(".migrated_div").style = "display:block;";
          document.getElementById("sc-launcher").style =
            "display:block;z-index:99999999;position:fixed";
          setInterval(this.LoadDate(), 5000);
        } else {
          // document.querySelector('.migrated_div').style="display:none;"
          //document.getElementById("sc-launcher").style = "display:none";
        }
      } else {
        document.querySelector(".migrated_div").style = "display:none;";
        document.getElementById("sc-launcher").style = "display:none";
      }
    });

    if (reactLocalStorage.get("role") === "ROLE_SUBADMIN") {
      this.setState({ showsub: true });
    }else{
      this.setState({ showsub: false })
    }
   
    
    var lang = i18n.language;
    if (reactLocalStorage.get("lang") === "ar") {
      i18n.changeLanguage("ar");
      this.setState({ isArabic: true });
      document.querySelector(".sc-header--team-name").style =
        "text-align:right";
      document.querySelector(".sc-chat-window").style =
        "margin-right: 305% !important;position: initial !important;margin-top: -71% !important;";
      document.querySelector(".main_div_loading").style = "direction:rtl";
      document.querySelector(".actionMenu").style =
        "margin-left: -8% !important;margin-right: 18% !important;";
      // document.querySelector(".beta_version_details").style = "padding-right: 65px;";
      //document.querySelector(".version_details").style = "padding-right: 65px;";
      if (this.state.collapsed) {
        document.querySelector(".menu_header").style =
          "width: 55% !important;margin-right: 119%;height: 37px !important; margin-top: 19% !important;";
      } else {
        //        document.querySelector(".menu_header").style = "margin-right:14%";
      }
      // document.querySelector('.menu_header').style = 'margin-right:14%';
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".big_div").style = "direction:rtl";
      document.querySelector(".emptyMenu").style = "padding-right: 12px";
      document.querySelector(".dashboard").style = "padding-right: 12px";
      document.querySelector(".profile").style = "padding-right: 12px";
     {/*................................New in 10-Jan-2025................................*/}
     document.querySelector(".migration").style = "padding-right: 12px";
     {/*..............................End New in 10-Jan-2025................................*/}
      document.querySelector(".request1").style = "padding-right: 12px";
     // document.querySelector(".invoice1").style = "padding-right: 12px";
      document.querySelector(".address1").style = "padding-right: 12px";
      document.querySelector(".logout").style = "padding-right: 12px";
      document.querySelector(".account1").style = "padding-right: 12px";
      document.querySelector(".sms1").style = "padding-right: 12px";

      document.querySelector(".menu_web").style = "margin-right: 6%;";
      document.querySelector(".logo_header_mobile").style = "float: right;";
      //      document.querySelector(".menu_mobile").style = "float: left;";
      document.querySelector(".navbar-collapse").style =
        "flex-basis: 81%;flex-grow: 0;";

      document.querySelector(".bulk1").style = "padding-right: 4px";
      document.querySelector(".profiled1").style = "padding-right: 4px";
      document.querySelector(".integration1").style = "padding-right: 4px";

      document.querySelector(".inter1").style = "padding-right: 4px";
      document.querySelector(".survey1").style = "padding-right: 4px";
      document.querySelector(".lba1").style = "padding-right: 4px";
      // document.querySelector(".sender1").style = "padding-right: 4px";
      document.querySelector(".contact1").style = "padding-right: 4px";
      document.querySelector(".group1").style = "padding-right: 4px";
      document.querySelector(".temp1").style = "padding-right: 4px";
      // document.querySelector(".balance1").style = "padding-right: 4px";
      document.querySelector(".account2").style = "padding-right: 4px";
    }

    if (
      reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
      reactLocalStorage.get("role") === "ROLE_OPERATOR_INT"
    ) {
      this.setState({ showStore: false });
      this.setState({ showContact: true });
      this.setState({ showAdminOperator: true });
      this.setState({ showOperatorSetting: true });
    }
    if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
      this.setState({ showAdmin: true });
      this.setState({ showAdminOperator: true });
    }

    if (reactLocalStorage.get("role") === "ROLE_SUBADMIN") {
      this.setState({ showsub: true });
    }
  
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
      this.setState({ superOperator: true });
   
    }
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");

    if (reactLocalStorage.get("authenticated") === "false") {
      document.querySelector(".main_div_loading").style = "display:none";
      window.location = "/app";
    } else {
      document.querySelector(".main_div_loading").style = "display:block";
    }

    if (reactLocalStorage.get("menucollapse") === "false") {
      this.toggleCollapsedRoute("close");
    }
  }

  LoadDate() {
    var callMigrated = setInterval(function() {
      var token = reactLocalStorage.get("accessToken");
      if (token === undefined) {
        window.location = "/app";
      }

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/loadbytokken";
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/loadbytokken";
      }

      var headers = { "Content-Type": "application/json", tokken: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        reactLocalStorage.set("migrated", res.data.result.migrated);
        reactLocalStorage.set('isPostPaid', res.data.result.packageID=='1692' ? 'true':'false')
       
        if (reactLocalStorage.get("migrated") != undefined) {
          if (reactLocalStorage.get("migrated") === "false") {
            document.querySelector(".migrated_div").style = "display:block;";
            document.getElementById("sc-launcher").style =
              "display:block;z-index:99999999;position:fixed";
          } else {
            document.querySelector(".migrated_div").style = "display:none;";
            document.getElementById("sc-launcher").style = "display:none";
            clearInterval(callMigrated);
          }
        } else {
          document.querySelector(".migrated_div").style = "display:none;";
          document.getElementById("sc-launcher").style = "display:none";
          clearInterval(callMigrated);
        }
      });
    }, 30000);
  }
  toggleCollapse = (collapseID) => () => {
    reactLocalStorage.set("menucollapse", collapseID);
    this.setState({
      open: !this.state.open,
    });
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));
  };

  toggleCollapsedRoute = (data) => {
    this.setState({
      open: !this.state.open,
    });

    this.setState({ collapsed: !this.state.collapsed });
    if (data == "open") {
    }
    if (data == "close") {
      test = "close";
      reactLocalStorage.set("menucollapse", false);
      document.querySelector(".app_details").style = "display:none";
      document.querySelector(".menu_new").style =
        "margin-left: 28%;margin-top: 27%;";
      document.querySelector(".actionMenu").style =
        "width:94.5%;margin-left: 7% !important;";
      document.querySelector(".menuWeb").style =
        "width:5.3%;background-color: #292828;";
      document.querySelector(".logo_header").style = "display:none !important";
      document.querySelector(".header_logo_web").style = "width:4.5em";
      //      document.querySelector(".menu_header").style =
      //       "margin-top: 15% !important;width:48% !important;margin-left: 30% !important";
      document.querySelector(".sms_collapse").style = "display:block";

      if (this.state.showsub == false) {
        document.querySelector(".account_collapse").style = "display:block";
      }

      if (this.state.showStore) {
        document.querySelector(".address_collapse").style = "display:block";
      }
      if (reactLocalStorage.get("lang") === "ar") {
        document.querySelector(".actionMenu").style =
          "margin-left: -9% !important; margin-right: 6.3% !important;";

        //   document.querySelector(".main_div").style = "margin-right: 5% !important;";
        document.querySelector(".menu_new").style =
          "margin-right: 29%;margin-top: 21%;";
        document.querySelector(".sms_collapse").style =
          "margin-right: 33% !important;margin-top: 46% !important;";

        document.querySelector(".account_collapse").style =
          "margin-right: 33% !important;margin-top: 46% !important;";
        document.querySelector(".address_collapse").style =
          "margin-right: 33% !important;margin-top: 46% !important;";
        document.querySelector(".drop_content").style =
          "margin-left: 0% !important;left: -545% !important;";
        document.querySelector(".ui.dropdown .menu > .item").style =
          "text-align:right;";
        document.querySelector(".group_collapse_web").style =
          "text-align:right;";
        document.querySelector(".temptitle").style = "text-align:right;";
        document.querySelector(".balance_collapse_web").style =
          "text-align:right;";
        //  document.querySelector(".drop_content_settings").style = "margin-left: 0% !important;left: -545% !important;";

        document.querySelector(".drop_content_account").style =
          "margin-left: 0% !important;left: -545% !important;";
        document.querySelector(".drop_content_address").style =
          "margin-left: 0% !important;left: -545% !important;";
      }
      document.querySelector(".row").style = "margin-right: 11px !important;";
      document.querySelector(".sms_all").style = "display:none";

      document.querySelector(".address_all").style = "display:none";
      document.querySelector(".account_all").style = "display:none";
      document.querySelector(".mail").style = "zoom:1.5 !important";
      // document.querySelector(".balance").style = "zoom:1.5 !important";
      document.querySelector(".sender").style = "zoom:1.5 !important";
      document.querySelector(".request_balance").style = "zoom:1.5 !important";

      document.querySelector(".bulk_type").style = "display:none";
      document.querySelector(".group_type_web").style = "display:none";
      document.querySelector(".contact_type_web").style = "display:none";
      document.querySelector(".account_type_web").style = "display:none";
      document.querySelector(".balance_type_web").style = "display:none";
      document.querySelector(".sender_type_web").style = "display:none";
      document.querySelector(".template_type").style = "display:none";
      document.querySelector(".profiled_type").style = "display:none";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type").style = "dispaly:none";
      }
      document.querySelector(".lba_type").style = "display:none";
      document.querySelector(".survey_type").style = "display:none";
      document.querySelector(".international_type").style = "display:none";
      this.setState({ show: false });
      this.setState({ show_address: false });
      this.setState({ show_account: false });
      this.setState({ show_setting: false });
    }
  };

  toggleCollapsed = () => {
    this.setState({
      open: !this.state.open,
    });

    this.setState({ collapsed: !this.state.collapsed });

    if (this.state.collapsed) {
      test = "open";
      reactLocalStorage.set("menucollapse", true);
      document.querySelector(".menuWeb").style = "width:17%;";
      document.querySelector(".app_details").style = "display:block";
      document.querySelector(".actionMenu").style = "width:84.5%";
      document.querySelector(".menu_new").style =
        "margin-left: 19%;margin-top: 10%;";
      document.querySelector(".header_logo_web").style = "width: 13em;";

      document.querySelector(".logo_header").style =
        "display:inline-block !important";
      document.querySelector(".sms_collapse").style = "display:none";

      document.querySelector(".address_collapse").style = "display:none";

      document.querySelector(".account_collapse").style = "display:none";
      document.querySelector(".sms_all").style = "display:block";
      if (this.state.showStore) {
        document.querySelector(".address_all").style = "display:block";
      }
      if (this.state.showsub == false) {
        document.querySelector(".account_all").style = "display:block";
      }
      document.querySelector(".mail").style = "zoom:1.5 !important";
      //document.querySelector(".balance").style = "zoom:1.5 !important";
      var lang = i18n.language;
      if (reactLocalStorage.get("lang") === "ar") {
        document.querySelector(".actionMenu").style = "width: 75.5%;";
        //        document.querySelector(".main_div").style = "margin-right: 21% !important;width: 100% !important;";
        document.querySelector(".menu_new").style = "margin-right: 11%;";
        document.querySelector(".actionMenu").style =
          "margin-left: -8% !important;margin-right: 18% !important;";
      }
    } else {
      test = "close";
      reactLocalStorage.set("menucollapse", false);
      document.querySelector(".app_details").style = "display:none";
      document.querySelector(".menu_new").style =
        "margin-left: 28%;margin-top: 27%;";
      document.querySelector(".actionMenu").style =
        "width:94.5%;margin-left: 7% !important;";
      document.querySelector(".menuWeb").style =
        "width:5.3%;background-color: #292828;";
      document.querySelector(".logo_header").style = "display:none !important";
      document.querySelector(".header_logo_web").style = "width:4.5em";
      //      document.querySelector(".menu_header").style =
      //       "margin-top: 15% !important;width:48% !important;margin-left: 30% !important";
      document.querySelector(".sms_collapse").style = "display:block";

      if (this.state.showsub == false) {
        document.querySelector(".account_collapse").style = "display:block";
      }

      if (this.state.showStore) {
        document.querySelector(".address_collapse").style = "display:block";
      }
      if (reactLocalStorage.get("lang") === "ar") {
        document.querySelector(".actionMenu").style =
          "margin-left: -9% !important; margin-right: 4.6% !important;";
        //   document.querySelector(".main_div").style = "margin-right: 5% !important;";
        document.querySelector(".menu_new").style =
          "margin-right: 29%;margin-top: 21%;";
        document.querySelector(".sms_collapse").style =
          "margin-right: 33% !important;margin-top: 46% !important;";

        document.querySelector(".account_collapse").style =
          "margin-right: 33% !important;margin-top: 46% !important;";
        document.querySelector(".address_collapse").style =
          "margin-right: 33% !important;margin-top: 46% !important;";
        document.querySelector(".drop_content").style =
          "margin-left: 0% !important;left: -545% !important;";
        document.querySelector(".ui.dropdown .menu > .item").style =
          "text-align:right;";
        document.querySelector(".group_collapse_web").style =
          "text-align:right;";
        document.querySelector(".temptitle").style = "text-align:right;";
        document.querySelector(".balance_collapse_web").style =
          "text-align:right;";
        document.querySelector(".drop_content_account").style =
          "margin-left: 0% !important;left: -545% !important;";
        //  document.querySelector(".drop_content_settings").style = "margin-left: 0% !important;left: -545% !important;";
        document.querySelector(".drop_content_address").style =
          "margin-left: 0% !important;left: -545% !important;";
      }
      document.querySelector(".row").style = "margin-right: 11px !important;";
      document.querySelector(".sms_all").style = "display:none";
      document.querySelector(".address_all").style = "display:none";
      document.querySelector(".account_all").style = "display:none";
      document.querySelector(".mail").style = "zoom:1.5 !important";
      // document.querySelector(".balance").style = "zoom:1.5 !important";
      document.querySelector(".sender").style = "zoom:1.5 !important";
      document.querySelector(".request_balance").style = "zoom:1.5 !important";
      document.querySelector(".bulk_type").style = "display:none";
      document.querySelector(".group_type_web").style = "display:none";
      document.querySelector(".contact_type_web").style = "display:none";
      document.querySelector(".account_type_web").style = "display:none";
      document.querySelector(".balance_type_web").style = "display:none";
      document.querySelector(".sender_type_web").style = "display:none";
      document.querySelector(".template_type").style = "display:none";
      document.querySelector(".profiled_type").style = "display:none";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type").style = "dispaly:none";
      }

      document.querySelector(".lba_type").style = "display:none";
      document.querySelector(".survey_type").style = "display:none";
      //document.querySelector(".international_type").style = "display:none";
      this.setState({ show: false });
      this.setState({ show_address: false });
      this.setState({ show_account: false });
    }
  };

  OpenDashboardAdv = () => {
    window.location = "dashboard";
  };

  OpenContact = () => {
    window.location = "contact";
  };
  OpenGroup = () => {
    window.location = "group";
  };
  OpenAccount = () => {
    window.location = "addsubadmin";
  };
  OpenBalance = () => {
    window.location = "addbalance";
  };
  OpenSender = () => {
    window.location = "SenderID";
  };
  ViewAddressBookWeb = () => {
    if (this.state.show_address === false) {
      document.querySelector(".group_type_web").style = "display:block";
      document.querySelector(".contact_type_web").style = "display:block";

      this.setState({ show_address: true });
    }
    if (this.state.show_address === true) {
      document.querySelector(".group_type_web").style = "display:none";
      document.querySelector(".contact_type_web").style = "display:none";

      this.setState({ show_address: false });
    }
  };
  ViewAccountWeb = () => {
    if (this.state.show_account === false) {
      document.querySelector(".account_type_web").style = "display:block";
      document.querySelector(".balance_type_web").style = "display:block";
      document.querySelector(".sender_type_web").style = "display:block";

      this.setState({ show_account: true });
    }
    if (this.state.showsub === true) {
      document.querySelector(".account_type_web").style = "display:none";
    }
    if (this.state.show_account === true) {
      document.querySelector(".account_type_web").style = "display:none";
      document.querySelector(".balance_type_web").style = "display:none";
      document.querySelector(".sender_type_web").style = "display:none";

      this.setState({ show_account: false });
    }
    if (this.state.showContact === true && this.state.show_account === false) {
      document.querySelector(".balance_type_web").style = "display:block";
      document.querySelector(".sender_type_web").style = "display:block";
      document.querySelector(".account_type_web ").style = "display:block";
      this.setState({ show_account: true });
    }
    if (this.state.superOperator === true) {
      document.querySelector(".sender_type_web").style = "display:block";
    }
  };

  ViewSMS = () => {
    if (this.state.show === false) {
      document.querySelector(".bulk_type").style = "display:block";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type").style = "display:block";
      }
      document.querySelector(".lba_type").style = "display:block";

      document.querySelector(".profiled_type").style = "display:block";
      /*
    document.querySelector('.survey_type').style = 'display:block';*/
     // document.querySelector(".international_type").style = "display:block";
      document.querySelector(".template_type").style = "display:block";
      this.setState({ show: true });
    }
    if (this.state.show === true) {
      document.querySelector(".bulk_type").style = "display:none";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type").style = "display:none";
      }
      document.querySelector(".lba_type").style = "display:none";
      document.querySelector(".profiled_type").style = "display:none";

      /*   document.querySelector(".survey_type").style = "display:none";*/
     // document.querySelector(".international_type").style = "display:none";
      document.querySelector(".template_type").style = "display:none";
      this.setState({ show: false });
    }
  };

  ViewSettings = () => {
    if (this.state.show_setting === false) {
      document.querySelector(".adv-setting").style = "display:block";
      document.querySelector(".senderid-setting").style = "display:block";

      this.setState({ show_setting: true });
    }
    if (this.state.show_setting === true) {
      document.querySelector(".adv-setting").style = "display:none";
      document.querySelector(".senderid-setting").style = "display:none";

      this.setState({ show_setting: false });
    }
  };
  ViewSMSCollapse = () => {};

  ViewSettingsCollapse = () => {};

  ViewAddressBook = () => {
    if (this.state.show_address === false) {
      document.querySelector(".group_mobile").style = "display:block";
      document.querySelector(".contact_mobile").style = "display:block";
      this.setState({ show_address: true });
    }
    if (this.state.show_address === true) {
      document.querySelector(".group_mobile").style = "display:none";
      document.querySelector(".contact_mobile").style = "display:none";
      this.setState({ show_address: false });
    }
  };
  ViewAccount = () => {
    if (this.state.show_account === false) {
      document.querySelector(".account_mobile").style = "display:block";
      document.querySelector(".balance_mobile").style = "display:block";
      document.querySelector(".sender_mobile").style = "display:block";
      this.setState({ show_account: true });
    }
    if (this.state.showsub === true) {
      document.querySelector(".account_mobile").style = "display:none";
    }
    if (this.state.show_account === true) {
      document.querySelector(".account_mobile").style = "display:none";
      document.querySelector(".balance_mobile").style = "display:none";
      document.querySelector(".sender_mobile").style = "display:none";
      this.setState({ show_account: false });
    }

    if (this.state.showContact === true || this.state.show_account === false) {
      document.querySelector(".sender_mobile").style = "display:block";
    }
    if (this.state.superOperator === true) {
      document.querySelector(".sender_mobile").style = "display:block";
    }
  };
  ViewSMSMobile = () => {
    if (this.state.show === false) {
      document.querySelector(".bulk_type_mobile").style = "display:block";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type_mobile").style =
          "display:block";
      }
      document.querySelector(".lba_type_mobile").style = "display:block";
      document.querySelector(".profiled_type_mobile").style = "display:block";

      /*document.querySelector('.survey_type_mobile').style = 'display:block';*/
      //document.querySelector(".international_type_mobile").style =
        //"display:block";
      document.querySelector(".template_type_mobile").style = "display:block";

      this.setState({ show: true });
    }
    if (this.state.show === true) {
      document.querySelector(".bulk_type_mobile").style = "display:none";
      document.querySelector(".profiled_type_mobile").style = "display:none";
      document.querySelector(".lba_type_mobile").style = "display:none";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type_mobile").style =
          "display:none";
      }
      document.querySelector(".survey_type_mobile").style = "display:none";
     // document.querySelector(".international_type_mobile").style =
       // "display:none";
      document.querySelector(".template_type_mobile").style = "display:none";
      this.setState({ show: false });
    }
  };

  ViewSMSMobile = () => {
    if (this.state.show  === false ) {
      
     
    if (this.state.showsub || this.state.showAdmin) {
      document.querySelector(".integration_type_mobile").style =
        "display:block";
    }
      document.querySelector(".bulk_type_mobile").style = "display:block";
    if( reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
        reactLocalStorage.get("role") === "ROLE_ADMIN") {

     if( reactLocalStorage.get('packageID')==='1692'){
      document.querySelector(".bulk_type_mobile").style = "display:block";
      document.querySelector(".lba_type_mobile").style = "display:block";
      document.querySelector(".profiled_type_mobile").style = "display:block";
      //document.querySelector(".international_type_mobile").style ="display:block";
        
     }
     else{
       if(reactLocalStorage.get('bulk')==='false'){
        document.querySelector(".bulk_type_mobile").style = "display:none";
       }else{
        document.querySelector(".bulk_type_mobile").style = "display:block";
       }
       if(reactLocalStorage.get('lba')==='false'){
        document.querySelector(".lba_type_mobile").style = "display:none";
       }
       else{
        document.querySelector(".lba_type_mobile").style = "display:block";
       }
       if(reactLocalStorage.get('profiled')==='false'){
        document.querySelector(".profiled_type_mobile").style = "display:none";
       }
       else{
        document.querySelector(".profiled_type_mobile").style = "display:block";
       }
       if(reactLocalStorage.get('international')==='false'){
        //document.querySelector(".international_type_mobile").style = "display:block";
       }
       else{
        //document.querySelector(".international_type_mobile").style = "display:block";
       }
     }
    }
      document.querySelector(".template_type_mobile").style = "display:block";

 /*  document.querySelector('.survey_type_mobile').style = 'display:block';*/
      this.setState({ show: true });
    }
    if (this.state.show === true) {
      document.querySelector(".bulk_type_mobile").style = "display:none";
      document.querySelector(".profiled_type_mobile").style = "display:none";
      if (this.state.showsub || this.state.showAdmin) {
        document.querySelector(".integration_type_mobile").style =
          "display:none";
      }
      document.querySelector(".lba_type_mobile").style = "display:none";
      document.querySelector(".survey_type_mobile").style = "display:none";
     // document.querySelector(".international_type_mobile").style =
       // "display:none";
      document.querySelector(".template_type_mobile").style = "display:none";
      this.setState({ show: false });
    }
  };

  logoutdata = () => {
    //  reactLocalStorage.set('authenticated','');
    // reactLocalStorage.set('accessToken','');
    //reactLocalStorage.set('user_id_login','');
    // reactLocalStorage.set('email_login','');
    // reactLocalStorage.set('loginDashboard',false)
    reactLocalStorage.clear();
  //  window.location = "app/";


      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/logout";
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/user/logout";
      }
      var data = {};
      var headers = {
        "content-type": "application/json",
        token:token
       
      };
      
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.status === "success") {
             
              
                window.location = "app/";
              
            }
            if(response.data.status === "failed")
            {
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.result.errorDescription,
                animation: "bounce",
                time: 5000
              });
              
              window.location = "app/";
              
            }
          }  else {
            console.log("Something wrong");
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
  
          });
          }
        })
        
    
  };
  openBulk = () => {
    window.location = "ReportBulk";
  };

  openLBA = () => {
    window.location = "LBA";
  };
  openProfiled = () => {
    window.location = "Profiled";
  };

  openIntegrationSMS = () => {
    window.location = "IntegrationSMS";
  };

  openInternational = () => {
    window.location = "InternationalSMS";
  };

  openAdvSetting = () => {
    window.location = "Settings";
  };
  openSenderIdSetting = () => {
    window.location = "SenderIdSetting";
  };
  openTemplate = () => {
    window.location = "Template";
  };
  componentWillMount() {
    if (reactLocalStorage.get("role") === "ROLE_SUBADMIN") {
      this.setState({ showsub: true });
    }

    if (reactLocalStorage.get("viewDownload") == "true") {
      this.setState({ showDownload: true });
    } else {
      this.setState({ showDownload: false });
    }
   
  }
  render() {
    return (
      <div className="main_div_loading">
        <div className="menu_mobile_hidden">
          <MDBNavbar color="green lighten-4" light>
            <div
              style={{
                display: "inline-flex",
                width: " 100%",
                borderBottom: "1px solid #dfdfdf",
              }}
            >
              <div style={{ width: " 50%" }}>
                <img
                  src={require("../pictures/ZB logo-02.png")}
                  className="logo_header_mobile"
                  alt="logo"
                  onClick={this.OpenDashboardAdv}
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div
                style={{ width: "18%", marginLeft: "41%", marginTop: "1%" }}
                className="menu_new_mobile"
              >
                <HamburgerMenu
                  isOpen={this.state.open}
                  menuClicked={this.toggleCollapse("navbarCollapse13")}
                  width={27}
                  height={15}
                  strokeWidth={1}
                  rotate={0}
                  color="#dfdfdf"
                  borderRadius={0}
                  animationDuration={0.5}
                  className="menu_new menu_mobile"
                  style={{ marginTop: "10%", marginLeft: " 16%" }}
                />
              </div>
            </div>
            <MDBCollapse
              id="navbarCollapse13"
              isOpen={this.state.collapseID}
              navbar
            >
              <MDBNavbarNav left>
                <MDBNavItem active onClick={this.OpenDashboard}>
                  <Link
                    to="/app/dashboard"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    style={{ pointerEvents: 'none', cursor: 'default' }}
                  >
                    {i18n.t("Dashboard.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem active>
                  <Link
                    to="/app/profile"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Profile.label")}
                  </Link>
                </MDBNavItem>
  {/*................................New in 10-Jan-2025................................*/}
               <MDBNavItem active>
                  <Link
                    to="/app/MigrationData"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    Migration Data
                  </Link>
                </MDBNavItem>
     {/*..............................End New in 10-Jan-2025................................*/}
      {/*................................New in 10-Jan-2025................................*/}
      <MDBNavItem active>
                  <Link
                    to="/app/JobDetails"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                   Job Details
                  </Link>
                </MDBNavItem>
     {/*..............................End New in 10-Jan-2025................................*/}
                <MDBNavItem active>
                  <Link
                    to="/app/RequestBalance"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Request_balance.label")}
                  </Link>
                </MDBNavItem>

                 {this.state.showInvoice ==true ? 
                   <MDBNavItem
                  active
          
                  
                >
                  <Link
                    to="/app/Invoices"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {this.state.isArabic ? "فواتير" : "Invoices"}
                  </Link>
                </MDBNavItem>:null}  

                {  reactLocalStorage.get("role") === "ROLE_ADMIN" ?  <MDBNavItem
                  active
          
                  
                >
                  <Link
                    to="/app/SubAdminJobs"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {this.state.isArabic ? "وظائف الإدارة الفرعية": "SubAdmin Jobs"}
                  </Link>
                </MDBNavItem>  :null}

              {  reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
                reactLocalStorage.get("role") === "ROLE_OPERATOR_INT"?
                <MDBNavItem
                  active
          
                  
                >
                  <Link
                    to="/app/JobsHistory"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {this.state.isArabic ? "تاريخ الوظائف": "Jobs History"}
                  </Link>
                </MDBNavItem>  :null}          

                <MDBNavItem
                  active
                  style={{
                    display: this.state.showOperatorSetting ? "block" : "none",
                  }}
                >
                  <Link
                    to="/app/Setting"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Settings.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem active onClick={this.ViewSMSMobile}>
                  <span style={{ cursor: 'pointer' }}>{i18n.t("SMS.label")}</span>
                </MDBNavItem>

              
                <MDBNavItem
                active
                className="bulk_type_mobile"
                style={{ display: "none" }}
                onClick={this.openBulk}
              >
                <span
                  onClick={this.toggleCollapse("navbarCollapse13")}
                  className="type_sms"
                  style={{ cursor: 'pointer' }}
                >
                  Bulk SMS 
                </span>
              </MDBNavItem>
               
                 
                <MDBNavItem
                  active
                  className="integration_type_mobile"
                  style={{ display: "none" }}
                  onClick={this.openIntegrationSMS}
                >
                  <span
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_sms"
                    style={{ cursor: 'pointer' }}
                  >
                    Integrated SMS
                  </span>
                </MDBNavItem>


               <MDBNavItem
                active
                className="profiled_type_mobile"
                style={{ display: "none" }}
                onClick={this.openProfiled}
              >
                <span
                  onClick={this.toggleCollapse("navbarCollapse13")}
                  className="type_sms"
                  style={{ cursor: 'pointer' }}
                >
                  Profiled SMS
                </span>
              </MDBNavItem>
                
                   
                 
        <MDBNavItem
                active
                className="lba_type_mobile"
                style={{ display: "none" }}
                onClick={this.openLBA}
              >
                <span
                  onClick={this.toggleCollapse("navbarCollapse13")}
                  className="type_sms"
                  style={{ cursor: 'pointer' }}
                >
                  LBA SMS 
                </span>
              </MDBNavItem>         

                <MDBNavItem
                  active
                  className="survey_type_mobile"
                  style={{ display: "none" }}
                >
                  <span
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_sms"
                    style={{ cursor: 'pointer' }}
                  >
                    Survey SMS
                  </span>
                </MDBNavItem>
               
  <MDBNavItem
                active
                className="international_type_mobile"
                style={{ display: "none" }}
                onClick={this.openInternational}
              >
                <span
                  onClick={this.toggleCollapse("navbarCollapse13")}
                  className="type_sms"
                  style={{ cursor: 'pointer' }}
                >
                  {" "}
                  International SMS
                </span>
              </MDBNavItem> 
            
                 
                <MDBNavItem
                  className="template_type_mobile"
                  style={{ display: "none" }}
                  active
                >
                  <Link
                    to="/app/Template"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_sms"
                  >
                    {i18n.t("Template.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  active
                  onClick={this.ViewAccount}
                  style={{ display: this.state.showsub ? "none" : "block" }}
                >
                  <span style={{ cursor: 'pointer' }}>
                    {this.state.showStore
                      ? i18n.t("manage_sub_accounts.label")
                      : i18n.t("manage_accounts.label")}{" "}
                  </span>
                </MDBNavItem>

                <MDBNavItem
                  className="create_type_sub account_mobile"
                  style={{ display: this.state.showsub ? "none" : "none" }}
                  active
                >
                  <Link
                    to="/app/addsubadmin"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_account"
                  >
                    <Icon />
                    {this.state.showStore
                      ? i18n.t("view_subadmin.label")
                      : i18n.t("view_admin.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  style={{ display: "none" }}
                  className="balance_mobile"
                  active
                >
                  <Link
                    to="/app/addbalance"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_account"
                  >
                    {i18n.t("add_balance.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  style={{ display: "none" }}
                  className="sender_mobile"
                  active
                >
                  <Link
                    to="/app/SenderID"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_account"
                  >
                    {i18n.t("create_sender_id.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  active
                  onClick={this.ViewAddressBook}
                  style={{ display: this.state.showStore ? "block" : "none" }}
                >
                  <span style={{ cursor: 'pointer' }}>
                    {i18n.t("Address_book.label")}
                  </span>
                </MDBNavItem>

                <MDBNavItem
                  style={{ display: "none" }}
                  className="group_mobile"
                  active
                >
                  <Link
                    to="/app/group"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_address"
                  >
                    {i18n.t("Groups.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  className="contact_mobile"
                  style={{ display: this.state.showStore ? "none" : "none" }}
                  active
                >
                  <Link
                    to="/app/contact"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                    className="type_address"
                  >
                    {i18n.t("Contact.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  style={{ display: this.state.showContact ? "block" : "none" }}
                  active
                >
                  <Link to="/app/ConatctUSView">
                    {i18n.t("contact_us.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem
                  style={{ display: this.state.showContact ? "none" : "none" }}
                >
                  <Link to="/app/Promotion">
                    {i18n.t("Promotion.label")}
                  </Link>
                </MDBNavItem>

                <MDBNavItem onClick={this.logoutdata} active>
                  <span style={{ cursor: 'pointer' }}>{i18n.t("Logout.label")}</span>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBNavbar>
        </div>

        <div className="menu_web">
          <div className="menuWeb">
            <Header floated="left" className="header_logo_web">
              <img
                src={require("../pictures/ZB logo-02.png")}
                className="logo_header"
                alt="logo"
                onClick={this.OpenDashboardAdv}
                style={{ cursor: "pointer" }}
              />
              <br />
              <br />
              <br />
              <Divider section />
              {/* <div className="menu_new">
                <HamburgerMenu
                  isOpen={this.state.open}
                  menuClicked={this.toggleCollapsed.bind(this)}
                  width={27}
                  height={15}
                  strokeWidth={1}
                  rotate={0}
                  color="#dfdfdf"
                  borderRadius={0}
                  animationDuration={0.5}
                />
              </div>
            
             */}
            </Header>
            <Menu
              mode="inline"
              theme="dark"
              inlineCollapsed={this.state.collapsed}
            >
              <div style={{ color: "transparent", marginTop: "50px" }}>
                .........
              </div>

              <Divider clearing />

              <Menu.Item key="1" onClick={this.OpenDashboard}>
                <Link to="/app/dashboard" className="linkStyle">
                  <Icon type="dashboard" className="bar_chart" />
                  <span className="emptyMenu dashboard">
                    {i18n.t("Dashboard.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item key="8">
                <Link to="/app/profile">
                  <Icon type="solution" className="user_profile" />
                  <span className="emptyMenu profile">
                    {i18n.t("Profile.label")}
                  </span>
                </Link>
              </Menu.Item>
                {/*................................New in 10-Jan-2025................................*/}
          
                <Menu.Item key="0101">
                <Link to="/app/MigrationData">
                  <Icon type="file" className="user_migration" />
                  <span className="emptyMenu migration">
                  Migration Data
                  </span>
                </Link>
              </Menu.Item>
                           
              {/* ................................End New in 10-Jan-2025...........................*/}

               {/*................................New in 10-Jan-2025................................*/}
          
               <Menu.Item key="0102">
                <Link to="/app/JobDetails">
                  <Icon type="file" className="user_jobDetails" />
                  <span className="emptyMenu JobDetails">
                  Job Details
                  </span>
                </Link>
              </Menu.Item>
                           
              {/* ................................End New in 10-Jan-2025...........................*/}

              <Menu.Item key="03">
                <Link to="/app/RequestBalance">
                  <Icon type="bars" className="request_balance" />
                  <span className="emptyMenu request1">
                    {i18n.t("Request_balance.label")}
                  </span>
                </Link>
              </Menu.Item>
              {this.state.showInvoice ==true? 

              <Menu.Item
                key="09"
              
              >
                <Link to="/app/Invoices">
                  <Icon type="container" className="invoices" />
                  <span className="emptyMenu invoice1" style={{paddingRight: '12px'}}>
                    {this.state.isArabic ? "فواتير" : "Invoices"}
                  </span>
                </Link>
              </Menu.Item> :null}


            {  reactLocalStorage.get("role") === "ROLE_ADMIN" ?
           <Menu.Item
                key="02"
              
              >
                <Link to="/app/SubAdminJobs">
                  <Icon type='bars' className="invoices" />
                  <span className="emptyMenu invoice1" style={{paddingRight: '12px'}}>
                  {this.state.isArabic ? "وظائف الإدارة الفرعية": "SubAdmin Jobs"}
                  </span>
                </Link>
              </Menu.Item> :null}

             

              {reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
                reactLocalStorage.get("role") === "ROLE_OPERATOR_INT"?  
                <Menu.Item
                key="05"
              
              >
                <Link to="/app/JobsHistory">
                  <Icon type='bars' className="invoices" />
                  <span className="emptyMenu invoice1" style={{paddingRight: '12px'}}>
                  {this.state.isArabic ? "تاريخ الوظائف": "Jobs History"}
                  </span>
                </Link>
              </Menu.Item>:null }

              <Menu.Item
                key="04"
                style={{
                  display: this.state.showOperatorSetting ? "block" : "none",
                }}
              >
                <Link to="/app/Setting">
                  <Icon type="setting" className="request_balance" />
                  <span className="emptyMenu request1">
                    {i18n.t("Settings.label")}
                  </span>
                </Link>
              </Menu.Item>

              {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

              <Menu.Item key="11" onClick={this.ViewSMS} className="sms_all">
                <Icon type="mail" className="sms" onClick={this.ViewSMS} />

                <span className="emptyMenu sms1" onClick={this.ViewSMS}>
                  {i18n.t("SMS.label")}
                </span>
                <Dropdown onClick={this.ViewSMS}>
                  <Dropdown.Menu onClick={this.ViewSMS} />
                </Dropdown>
              </Menu.Item>

              <Dropdown
                item
                icon="mail outline"
                style={{ display: "none" }}
                onClick={this.ViewSMSCollapse}
                className="sms_collapse"
                data-tip={i18n.t("SMS.label")}
              >
                <Dropdown.Menu className="drop_content">
                  <Dropdown.Item
                    icon="minus"
                    text="Bulk SMS"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                    }}
                    onClick={this.openBulk}
                  />
                  <Dropdown.Item
                    icon="minus"
                    text="Integrated SMS"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                    }}
                    onClick={this.openIntegrationSMS}
                  />
                  <Dropdown.Item
                    icon="minus"
                    text="Profiled SMS"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      display: "none",
                    }}
                  />
                  <Dropdown.Item
                    icon="minus"
                    text="LBA SMS"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      display: "none",
                    }}
                  />
                  <Dropdown.Item
                    icon="minus"
                    text="Survay SMS"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      display: "none",
                    }}
                  />
                  <Dropdown.Item
                    icon="minus"
                    text="International SMS"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      display: "none",
                    }}
                  />
                  <Dropdown.Item
                    className="temptitle"
                    icon="minus"
                    text={i18n.t("Template.label")}
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                    }}
                    onClick={this.openTemplate}
                  />
                </Dropdown.Menu>
              </Dropdown>
              <ReactTooltip />
              <Menu.Item
                key="111"
                className="bulk_type"
                style={{ display: "none" }}
                onClick={this.openBulk}
                disabled={
                  reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_ADMIN"
                    ? reactLocalStorage.get("packageID") === "1692"
                      ? false
                      : reactLocalStorage.get("bulk") === "true"
                      ? false
                      : true
                    : ""
                }
              >
                <Icon type="minus" className="sms_sub" />
                <span className="emptyMenu bulk1">Bulk SMS</span>
              </Menu.Item>

              <Menu.Item
                key="121"
                className="integration_type"
                style={{ display: "none" }}
                onClick={this.openIntegrationSMS}
              >
                <Icon type="minus" className="sms_sub" />
                <span className="emptyMenu integration1"> Integrated SMS</span>
              </Menu.Item>

              <Menu.Item
                key="141"
                className="profiled_type"
                style={{ display: "none" }}
                onClick={this.openProfiled}
                disabled={
                  reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_ADMIN"
                    ? reactLocalStorage.get("packageID") === "1692"
                      ? false
                      : reactLocalStorage.get("profiled") === "true"
                      ? false
                      : true
                    : ""
                }
              >
                <Icon type="minus" className="sms_sub" />
                <span className="emptyMenu profiled1">Profiled SMS</span>
              </Menu.Item>

              <Menu.Item
                key="131"
                className="lba_type"
                style={{ display: "none" }}
                onClick={this.openLBA}
                disabled={
                  reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_ADMIN"
                    ? reactLocalStorage.get("packageID") === "1692"
                      ? false
                      : reactLocalStorage.get("lba") === "true"
                      ? false
                      : true
                    : ""
                }
              >
                <Icon type="minus" className="sms_sub" />
                <span className="emptyMenu lba1">LBA SMS</span>
              </Menu.Item>

              <Menu.Item
                key="1233"
                className="survey_type"
                style={{ display: "none" }}
              >
                <Icon type="mail" className="sms_sub" />
                <span className="emptyMenu survey1">Survay SMS</span>
              </Menu.Item>

              <Menu.Item
                key="34"
                className="international_type"
                style={{ display: "none" }}
                onClick={this.openInternational}
                disabled={
                  reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_ADMIN"
                    ? reactLocalStorage.get("packageID") === "1692"
                      ? false
                      : reactLocalStorage.get("international") === "true"
                      ? false
                      : false
                    : ""
                }
              >
                <Icon type="minus" className="sms_sub" />
                <span className="emptyMenu inter1">International SMS</span>
              </Menu.Item> 

              <Menu.Item
                key="043"
                style={{ display: "none" }}
                className="template_type"
              >
                <Link to="/app/Template">
                  <Icon type="minus" className="sms_sub" />
                  <span className="emptyMenu temp1">
                    {i18n.t("Template.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="101"
                onClick={this.ViewAccountWeb}
                className="account_all"
                style={{ display: this.state.showsub ? "none" : "block" }}
              >
                <Icon
                  type="setting"
                  className="account_web"
                  onClick={this.ViewAccountWeb}
                />
                <span
                  className="emptyMenu account1"
                  onClick={this.ViewAccountWeb}
                >
                  {this.state.showStore
                    ? i18n.t("manage_sub_accounts.label")
                    : i18n.t("manage_accounts.label")}
                </span>
                <Dropdown onClick={this.ViewAccountWeb}>
                  <Dropdown.Menu onClick={this.ViewAccountWeb} />
                </Dropdown>
              </Menu.Item>

              <Dropdown
                item
                icon="user outline"
                style={{ display: "none" }}
                onClick={this.ViewAddressCollapse}
                className="account_collapse"
                data-tip={i18n.t("manage_accounts.label")}
              >
                <Dropdown.Menu className="drop_content drop_content_account">
                  <Dropdown.Item
                    icon="add user"
                    className="user_add"
                    onClick={this.OpenAccount}
                    text={
                      this.state.showStore || this.state.superOperator
                        ? i18n.t("Create_Sub_Admin.label")
                        : i18n.t("View_Admin.label")
                    }
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      fontSize: "7px",
                      display:
                        this.state.showAdminOperator || this.state.superOperator
                          ? "block"
                          : "none",
                    }}
                  />

                  <Dropdown.Item
                    icon="plus"
                    className="balance_collapse_web"
                    onClick={this.OpenBalance}
                    text={i18n.t("add_balance.label")}
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      fontSize: "7px",
                    }}
                  />

                  <Dropdown.Item
                    icon="comment"
                    className="sender_collapse_web"
                    onClick={this.OpenSender}
                    text={i18n.t("create_sender_id.label")}
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      fontSize: "7px",
                    }}
                  />
                </Dropdown.Menu>
              </Dropdown>

              <ReactTooltip />
              <Menu.Item
                key="3"
                className="account_type_web"
                style={{ display: "none" }}
              >
                <Link to="/app/addsubadmin">
                  <Icon type="user" className="user_add" />
                  <span className="create_type_sub account2">
                    {this.state.showStore
                      ? i18n.t("create_sub_admin.label")
                      : i18n.t("view_admin.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="07"
                className="balance_type_web"
                style={{ display: "none" }}
              >
                <Link to="/app/addbalance">
                  <Icon type="user" className="user_add" />
                  <span className="create_type_sub account2">
                    {i18n.t("add_balance.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="1133"
                className="sender_type_web"
                style={{ display: "none" }}
              >
                <Link to="/app/SenderID">
                  <Icon type="user" className="sender" />
                  <span className="create_type_sub account2">
                    {i18n.t("create_sender_id.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="100"
                onClick={this.ViewAddressBookWeb}
                className="address_all"
                style={{ display: this.state.showStore ? "block" : "none" }}
              >
                <Icon
                  type="user"
                  className="address"
                  onClick={this.ViewAddressBookWeb}
                />
                <span
                  className="emptyMenu address1"
                  onClick={this.ViewAddressBookWeb}
                >
                  {i18n.t("Address_book.label")}
                </span>
                <Dropdown onClick={this.ViewAddressBookWeb}>
                  <Dropdown.Menu onClick={this.ViewAddressBookWeb} />
                </Dropdown>
              </Menu.Item>

              <Dropdown
                item
                icon="id card"
                style={{ display: "none" }}
                className="address_collapse"
                data-tip={i18n.t("Address_book.label")}
              >
                <Dropdown.Menu className="drop_content drop_content_address">
                  <Dropdown.Item
                    icon="id card"
                    text={i18n.t("Contact.label")}
                    onClick={this.OpenContact}
                    className="contact_collapse_web"
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      fontSize: "7px",
                      zoom: "0 !important",
                    }}
                  />
                  <Dropdown.Item
                    icon="user"
                    text={i18n.t("Groups.label")}
                    className="group_collapse_web"
                    onClick={this.OpenGroup}
                    style={{
                      marginLeft: "0% !important",
                      marginTop: "0%!important",
                      fontSize: "7px",
                    }}
                  />
                </Dropdown.Menu>
              </Dropdown>
              <ReactTooltip />
              <Menu.Item
                key="310"
                className="group_type_web"
                style={{ display: "none" }}
              >
                <Link to="/app/group">
                  <Icon type="usergroup-add" className="group" />
                  <span className="emptyMenu group1">
                    {i18n.t("Groups.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="4"
                onClick={this.OpenContact}
                className="contact_type_web"
                style={{ display: "none" }}
              >
                <Icon type="phone" className="phone" />
                <span className="emptyMenu contact1">
                  {i18n.t("Contact.label")}
                </span>
              </Menu.Item>

              <Menu.Item
                key="17"
                style={{ display: this.state.showContact ? "block" : "none" }}
              >
                <Link to="/app/ConatctUSView">
                  <Icon type="phone" className="contact_us" />
                  <span className="emptyMenu">
                    {i18n.t("contact_us.label")}
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="171"
                style={{ display: this.state.showContact ? "none" : "none" }}
              >
                <Link to="/app/Promotion">
                  <Icon type="gift" className="promotion" />
                  <span className="emptyMenu">{i18n.t("Promotion.label")}</span>
                </Link>
              </Menu.Item>

              <Menu.Item key="7" onClick={this.logoutdata}>
                <Icon type="logout" className="logout_icon" />
                <span className="emptyMenu logout">
                  {i18n.t("Logout.label")}
                </span>
              </Menu.Item>

              <Menu.Item
                style={{ color: "white", fontSize: "11.5px" }}
                className="app_details"
              >
                Zain Jordan Business Group {"\u00A9"} 2020
              </Menu.Item>
            </Menu>
          </div>

          <SemanticToastContainer />

          <div className="modal_ads">
            <Modal
              isOpen={this.state.modalIsOpen}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <h2 ref={(subtitle) => (this.subtitle = subtitle)} />
              <br />
              <div className="slider_auth">
                <div>
                  <Carousel
                    style={{ width: "20%" }}
                    arrowLeft={
                      <Icon
                        className="icon-example"
                        type="left-circle"
                        style={{ zoom: "2", padding: "3px" }}
                      />
                    }
                    arrowRight={
                      <Icon
                        className="icon-example"
                        type="right-circle"
                        style={{ zoom: "2", padding: "3px" }}
                      />
                    }
                    addArrowClickHandler
                  >
                    <img
                      src={require("../pictures/slider.jpg")}
                      className="slider_pic"
                    />
                    <img
                      src={require("../pictures/slider2.jpg")}
                      className="slider_pic"
                    />
                    <img
                      src={require("../pictures/slider3.png")}
                      className="slider_pic"
                    />
                  </Carousel>
                </div>
              </div>
              <Button onClick={this.closeModal} className="close_btn">
                {i18n.t("Close.label")}
              </Button>
            </Modal>
          </div>
        </div>
        <div className="migrated_div" style={{ display: "none" }}>
          {this.state.isArabic ? (
            <Launcher
              agentProfile={{
                teamName: i18n.t("corpsms_notification.label"),
                imageUrl: require("../pictures/sms-message.png"),
              }}
              messageList={this.state.messageListaraic}
              showEmoji
              isOpen
            />
          ) : (
            <Launcher
              agentProfile={{
                teamName: i18n.t("corpsms_notification.label"),
                imageUrl: require("../pictures/sms-message.png"),
              }}
              messageList={this.state.messageList}
              showEmoji
              isOpen
            />
          )}
        </div>
        {/*}
        {this.state.showDownload ?
        <DownloadToast/>
        :
        ''
        }
      */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};

export default connect(mapStateToProps)(Menutest);
